import { Box, Center, Text, VStack } from '@chakra-ui/react';
import { MdOutlineInbox } from 'react-icons/md';
import CardDetailMobilePage, { IResourceItem } from './cardDetail';

interface IOwnProps {
  data?: IResourceItem[];
  isImpugnation: boolean;
  onOpenUpdateResource(id: string): void;
  isUpdateOrDelete?: boolean;
}

const ListSolicitationResource: React.FC<IOwnProps> = ({
  data = [],
  isImpugnation,
  onOpenUpdateResource,
  isUpdateOrDelete,
}) => {
  if (!data || data.length === 0)
    return (
      <Box h="full" p={4}>
        <Center h="100%">
          <VStack spacing={0} transform="translateY(-20%)">
            <MdOutlineInbox size={30} color="#969696" />
            <Text fontSize="0.9rem" mt={3} textAlign="center">
              Você ainda não solicitou {isImpugnation ? 'nenhuma impugnação' : 'nenhum recurso'}.
            </Text>
            <Text fontSize="x-small" color="gray.500" textAlign="center">
              Suas solicitações aparecerão aqui assim que você adicionar{' '}
              {isImpugnation ? 'alguma impugnação' : 'algum recurso'}.
            </Text>
          </VStack>
        </Center>
      </Box>
    );

  return data?.map((item) => (
    <CardDetailMobilePage
      onOpenUpdateResource={onOpenUpdateResource}
      isImpugnation={isImpugnation}
      isUpdateOrDelete={isUpdateOrDelete}
      key={item.id}
      item={item}
    />
  ));
};

export default ListSolicitationResource;
